/**
 * The only two events this system records. Mirrored server-side by
 * EVENT_NAMES in apps/server/src/models/AnalyticsEvent.js — keep them in sync.
 * The server drops anything not in its list.
 */
export const EVENT_CATALOG = {
  session_start: 'session_start',
  app_view: 'app_view',
} as const;

export type EventName = keyof typeof EVENT_CATALOG;

export interface AnalyticsEventPayload {
  eventName: EventName;
  clientId: string;
  sessionId: string;
  /** Route slug of the app, e.g. "resus". Set on app_view only. */
  appName?: string | null;
}
